export default __webpack_public_path__ + "static/media/Raavi.93996c9f.ttf";